// extracted by mini-css-extract-plugin
export default {"wrapper":"kp","form":"lp","circle":"mp","success":"np","button":"op"};